<template>
    <form @submit.prevent="create" class="main-form">
        <custom-input
            :title="$t('WEBSHOPS__NAME')"
            v-model="name"
            @clear="name = ''"
            helperText="*Required"
            :isRequired=true
        />
        <custom-input
            :title="$t('WEBSHOPS__USER_FULL_NAME')"
            v-model="userFullName"
            @clear="userFullName = ''"
            helperText="*Required"
            :isRequired=true
        />
        <custom-input
            :title="$t('WEBSHOPS__LOGIN_USERNAME')"
            v-model="userName"
            @clear="userName = ''"
            helperText="Not Required"
        />
        <custom-input
            :title="$t('WEBSHOPS__PASSWORD')"
            v-model="password.value"
            @clear="password.value = ''"
            :isError="password.isError"
            :errorMessage="password.errorMessage"
            helperText="6 Symbols Minimum"
            inputType="password"
            :isRequired=true
        />
        <switcher
            title="Locked"
            v-model="locked"
        />
        <button class="btn">{{ $t('WEBSHOPS__CREATE') }}</button>
    </form>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import Switcher from '@/components/ReusableComponents/Switcher/Switcher.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        CustomInput,
        Switcher,
    },
    data() {
        return {
            name: '',
            userFullName: '',
            password: {
                value: '',
                isError: false,
                errorMessage: 'Must be minimum 6 symbols long',
            },
            locked: false,
            userName: '',
        }
    },
    methods: {
        create() {
            if(this.password.value.length < 6) {
                this.password.isError = true
                return
            }
            this.password.isError = false
            axios
                .post('WebShop/CreateWebShop', {
                    name: this.name ? this.name : null,
                    userFullName: this.userFullName ? this.userFullName : null,
                    password: this.password.value,
                    locked: this.locked,
                    userName: this.userName ? this.userName : null
                })
                .then(resp => {
                    if(resp.data.status == 1) {
                        this.password.value = ''
                        this.locked = false
                        this.name = ''
                        this.userFullName = ''
                        this.userName = ''
                        this.$emit('done', {
                            purpose: 'success',
                            text: 'Successfully Created!',
                        })
                    }else {
                        let text = 'An Error Has Occurred While Creating!'
                        var code = this.statusCodes.filter(e => e.key == status)[0]
                        if (code) text = this.$t('STATUS-CODE__' + code.value)
                        this.$emit('done', {
                            purpose: 'error',
                            text: text,
                        })
                    }
                })
                .catch(() => {
                    this.$emit('done', {
                            purpose: 'error',
                            text: 'An Error Has Occurred While Creating!',
                        })
                })
        }
    }
}
</script>

<style lang="scss" scoped>
form {
    margin-top: 5vw;
    display: flex;

    /deep/ label {
        margin-right: 15 * $rem;
    }
}
</style>
